import createApi from "../utils/apiClient";
const api = createApi();

export const getBooks =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: "BOOKS_REQUEST" });
      const { data } = await api.get("/library/books", { params });
      dispatch({ type: "BOOKS_SUCCESS", payload: data.books });
    } catch (err) {
      dispatch({ type: "BOOKS_FAIL", payload: err.response?.data?.message });
    }
  };

export const addBook = (formData) => async (dispatch) => {
  try {
    dispatch({ type: "BOOK_REQUEST" });
    const { data } = await api.post("/library/books", formData);
    dispatch({ type: "BOOK_SUCCESS", payload: data.book });
    dispatch(getBooks());
    return data;
  } catch (err) {
    dispatch({ type: "BOOK_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};

export const issueBook = (formData) => async (dispatch) => {
  try {
    const { data } = await api.post("/library/issue", formData);
    dispatch(getBooks());
    return data;
  } catch (err) {
    throw err;
  }
};

export const returnBook = (id) => async (dispatch) => {
  try {
    const { data } = await api.put(`/library/return/${id}`);
    dispatch(getBooks());
    return data;
  } catch (err) {
    throw err;
  }
};
